import React from "react";
import List from "@commonComponents/List";
import ExitInformationForm from "@EUForms/exitInformationForm";
import { useSelector } from "react-redux";
import { selectExitInfoList } from "@EUForms/selectors";


const ExitInformationDetail = ({isDisabled,dataSource,...rest}) => {
   const exitInfoList=useSelector(selectExitInfoList)

   const validateExitInfo=(selectedValue,id)=>{
    if(!selectedValue?.trim() || exitInfoList.find(c=>c.value==selectedValue)?.additionalInfo?.toUpperCase()!="AAZ") //  if selected type is not AAZ then skip condition
         return false

     // select all updated exit Information
    const selectedExitInfoIds=dataSource.reduce((prev,curr)=>{
       if(!curr.exitInfo?.trim() || id==curr.id) return prev
       return {...prev,[`${curr.exitInfo}`]:true}
    },{})
   
    // check if AAZ already exists
   
   return exitInfoList.some(({value,additionalInfo})=>(selectedExitInfoIds[value]  && additionalInfo?.toUpperCase()=="AAZ"))
    
   }
  const renderItem=(item)=> <ExitInformationForm 
  dataSource={item} 
  key={item.id} 
  exitInfoList={exitInfoList}
  validateExitInfo={validateExitInfo}
  {...rest}
  isDisabled={isDisabled}
   />

  
  return  <List className="responsiveGridCss" dataSource={dataSource} renderItem={renderItem} />
}

export default React.memo(ExitInformationDetail)
